export default __webpack_public_path__ + "static/media/crewdev_logo.8347d3e0.png";